const images = Array.from({ length: 10 }, (_, i) =>
  require(`../../assets/img/reel-section/gallery-section/gallery-photos/${
    i + 1
  }.png`)
);

export default images;
